import * as React from "react";

const DropDown = ({
  type,
  dropDownData,
  onChange,
  modal,
  modalid,
  optionKey,
  defaultValue,
  defaultOptionName,
  customClass,
  value,
  multiple,
}) => {
  return (
    <select
      value={value}
      className={
        type === "primary"
          ? "form-select bg-berylline"
          : `form-select  field-white ${customClass}`
      }
      defaultValue={defaultValue}
      onChange={(e) => onChange && onChange(e.target.value)}
      multiple={multiple}
    >
      <option value={defaultValue || ""} selected disabled hidden>
        {defaultOptionName || defaultValue}
      </option>
      {dropDownData?.length
        ? dropDownData?.map(({ option }, index) => (
            <option
              key={index}
              value={optionKey ? dropDownData[index].id : option}
              modal={modal}
              modalid={modalid}
            >
              {optionKey ? dropDownData[index][optionKey] : option}
            </option>
          ))
        : []}
    </select>
  );
};

export default DropDown;
